import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllBankBranches.graphql';
import { Query, QueryallBankBranchesArgs } from '../../__generated__/globalTypes';

export const useAllBankBranchesQuery = (options?: QueryHookOptions<Query, QueryallBankBranchesArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallBankBranchesArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllBankBranchesLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallBankBranchesArgs>
): QueryResult<Query, QueryallBankBranchesArgs> & {
  getAllBankBranches: LazyQueryExecFunction<Query, QueryallBankBranchesArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllBankBranches, result] = useLazyQuery<Query, QueryallBankBranchesArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllBankBranches, ...result };
};

export const useAllBankBranchesPromiseQuery = () => {
  const client = useApolloClient();

  const getAllBankBranches = useCallback(
    (options?: Omit<QueryOptions<QueryallBankBranchesArgs, Query>, 'query'>) =>
      client.query<Query, QueryallBankBranchesArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllBankBranches };
};
// Suspense Query Hooks
export const useAllBankBranchesSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallBankBranchesArgs>
) => {
  const result = useSuspenseQuery<Query, QueryallBankBranchesArgs>(QUERY, {
    ...options
  });

  return result;
};
